import { httpRequest } from 'http'

export const CLAN_LANDING_REQUEST_SUCCESS = 'CLAN_LANDING_REQUEST_SUCCESS'
export const clanRequestSuccess = (level) => ({
    type: CLAN_LANDING_REQUEST_SUCCESS,
    payload: {
        level,
    },
})

export function requestClanLanding() {
    return async (dispatch) => {
        const response = await httpRequest('/game_api/clan_landing')

        dispatch(clanRequestSuccess(response.stronghold_level))
    }
}



// WEBPACK FOOTER //
// ./state/actions/clan_landing.js